const swatchImageCache = new Map();

const buildKey = (sku, title, sortOrder) => `${sku}::${title}::${sortOrder}`;

export const cacheSwatchImage = (sku, title, sortOrder, base64) => {
  if (base64) {
    swatchImageCache.set(buildKey(sku, title, sortOrder), base64);
  }
};

export const getCachedSwatchImage = (sku, title, sortOrder) => (
  swatchImageCache.get(buildKey(sku, title, sortOrder))
);
